import React from 'react';
import './Loader.sass'

const Loader = () => {
	return (
		<div className="no__loader">
			<svg
				version="1.1"
				id="lkw__loader"
				x="0px" y="0px"
				viewBox="0 0 112.1 112.1"
				style={{enableBackground: "new 0 0 112.1 112.1"}}>
					<path className="no__svg-truck" d="M27.7,65.8c2.6,0,4.7,2.2,4.7,4.8s-2.2,4.7-4.8,4.7c-2.6,0-4.7-2.1-4.7-4.8C22.9,67.9,25,65.8,27.7,65.8z M57.2,65.8c2.6,0,4.7,2.2,4.7,4.8c0,2.6-2.2,4.7-4.8,4.7c-2.6,0-4.7-2.1-4.7-4.8C52.5,67.9,54.6,65.8,57.2,65.8z M81.5,65.8 c2.6,0,4.7,2.2,4.7,4.8c0,2.6-2.2,4.7-4.8,4.7c-2.6,0-4.7-2.1-4.7-4.8C76.7,67.9,78.9,65.8,81.5,65.8z M66.4,58.4v11h-2.2 c-0.6-3.8-4.2-6.5-8.1-5.9c-3,0.5-5.4,2.8-5.9,5.9H34.6c-0.6-3.8-4.2-6.5-8.1-5.9c-3,0.5-5.4,2.8-5.9,5.9H19v-11H66.4z M74.1,40.5 c0.4,0,0.8,0.1,1,0.4c0.3,0.3,0.4,0.6,0.4,1v9.4c0,1,0.4,1.9,1,2.6c0.7,0.7,1.6,1.1,2.6,1.1h12.6l2.4,3.2c0.5,0.7,0.8,1.6,0.8,2.4v9 h-6.6c-0.6-3.8-4.2-6.5-8.1-5.9c-3,0.5-5.4,2.8-5.9,5.9h-5.9v-29L74.1,40.5z M59.3,31.7c2.4,0,4.3,2,4.4,4.4v13c0,2.4-2,4.3-4.4,4.4 H23.7c-2.4,0-4.3-2-4.3-4.4V36c0-2.4,1.9-4.3,4.3-4.4H59.3z M83.3,43.7c1.5,0,2.8,0.8,3.5,2.1l3.7,6.9H79.2c-0.4,0-0.7-0.1-1-0.4 c-0.3-0.3-0.4-0.6-0.4-1v-7.6L83.3,43.7z M37.7,28.2v1.3h-8.5v-1.3H37.7z"/>
					<circle className="no__svg-circle" cx="56" cy="56" r="53.5"/>
			</svg>
		</div>
	);
};

export default Loader;
